import moment from 'moment'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { get, set } from 'lodash'
import { Model } from '@src/models'
import { Sort } from '@src/models/app.types'
import { toKeyValuePairs } from '@transforms'
import { Caching } from '@utils'
import { RootStoreState } from '@src/models/app.types'
import { DEFAULT_PAGE_SIZE } from '@src/components/list/DataProviderList'
import commonReducers from '@src/models/commonReducers'
import { Variables } from '@src/utils/caching'
import { transformHistoryOrEventItem } from '@src/transforms/eventAndHistoryItemTransform'
import ALL_EVENTS from '../graphql/allIEvents'
import { EventsFilter, EventsStoreState } from './events.types'
import { EVENTS_DEFAULT_STATE } from './constants'

interface Effects {
  select: () => RootStoreState
}

export default class Events {
  namespace = 'events'

  state: EventsStoreState = EVENTS_DEFAULT_STATE

  effects = {
    fetch: Model.buildEffect({
      name: `${this.namespace}/fetch`,
      query: ALL_EVENTS,
      dataPath: 'allEvents',
      *variables(payload: EventsFilter | undefined, { select }: Effects) {
        let resultPayload = payload

        if (!resultPayload) {
          const state: RootStoreState = yield select()
          const filter: Sort = { ...state.events.sort, scope: 'events' }

          resultPayload = {
            filter,
            pagination: {
              page: 1,
              pageSize: DEFAULT_PAGE_SIZE,
              type: 'date',
              endTime: moment(state.app.calendar.endDate).endOf('day').toISOString(),
            },
          }
        }

        return set(
          resultPayload,
          'filter.types',
          toKeyValuePairs(get(resultPayload, 'filter.types')),
        )
      },
      caching: (variables: Variables) => Caching.shouldUseDateRangeCache(variables.filter),
      cacheKey: (variables: Variables) => Caching.listFilterCacheKey('events/fetch', variables),
      reducers: [
        {
          name: 'fetchListInfinite',
          dataPath: 'events.events',
          storePath: 'events',
          transform: transformHistoryOrEventItem,
        },
      ],
    }),
  }

  reducers = {
    ...Model.defaultReducers,
    updateListItem: commonReducers.updateListItem,
    appendOrReplaceList: commonReducers.appendOrReplaceList,
    deleteList: commonReducers.deleteList,
    backup: commonReducers.backup,
    restore: commonReducers.restore,
    updateSort: commonReducers.updateSort,
    fetchListInfinite: commonReducers.fetchListInfinite,
  }
}
